import { CentricTypography as Typography } from '@core/component/CentricTypography'
import isEmpty from 'lodash/isEmpty'
import { useObserver } from 'mobx-react-lite'
import React, { FC } from 'react'
import { useTranslation } from 'react-i18next'
import formatCurrencyValueByLocale from '@utils/format-currency-value-by-locale'
import { makeStyles } from '@material-ui/core'

interface IGradingNotes {
  rowData: any
  currency: string
  isGradingEnabledForProduct: boolean
  gradingAttributes: any
}

const useStyles = makeStyles(() => ({
  summaryContainer: {
    padding: '6px 0px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexDirection: 'column',
    width: '100%'
  },
  summaryTxt: {
    paddingTop: 4
  }
}))

const GradingNotes: FC<IGradingNotes> = ({
  rowData,
  currency,
  isGradingEnabledForProduct,
  gradingAttributes
}) =>
  useObserver(function useHook() {
    const { t } = useTranslation()
    const classes = useStyles()
    return (
      <div className={classes.summaryContainer}>
        <Typography variant={'body2LightGrey'}>
          {formatCurrencyValueByLocale(currency, rowData?.clientOrderProductValue || 0)}
        </Typography>
        {isGradingEnabledForProduct && (
          <>
            <Typography variant={'body2LightGrey'} className={classes.summaryTxt}>
              {!isEmpty(gradingAttributes)
                ? `Grading: ${gradingAttributes?.grade ?? ''}.`
                : t('order.quantitiesAndBook.emptyGrading', 'No grading selected.')}
            </Typography>
            {!isEmpty(gradingAttributes) && (
              <Typography variant={'body2LightGrey'} className={classes.summaryTxt}>
                {`Target ROS is ${gradingAttributes?.grade}.`}
              </Typography>
            )}
            <Typography variant={'body2LightGrey'} className={classes.summaryTxt}>
              {!isEmpty(gradingAttributes)
                ? `Shelf life is ${gradingAttributes?.shelfLife ?? ''}`
                : t('order.quantitiesAndBook.defaultShelf', 'Default shelf life is 1.')}
            </Typography>
            <Typography variant={'body2LightGrey'} className={classes.summaryTxt}>
              {!isEmpty(gradingAttributes)
                ? `Buffer is ${gradingAttributes?.buffer ?? ''}%.`
                : t('order.quantitiesAndBook.defaultBuffer', 'Default buffer is 0.')}
            </Typography>
          </>
        )}
      </div>
    )
  })

export default GradingNotes
